import React from "react"

interface Props {
    percentage: number
}

export const ProgressBar: React.FC<Props> = ({ percentage }) => {
    return (
        <div className="progress-bar">
            <Filler percentage={percentage} />
        </div>
    )
}

export const Filler: React.FC<Props> = ({ percentage }) => {
    return <div className="filler" style={{ width: `${percentage}%` }} />
}

ProgressBar.displayName = "ProgressBar"
export default Props
